import React from 'react';

class CalculatorCostsBreakdown extends React.Component {
  render() {
    return (
      <div className="calculator-costs-breakdown">
        <div className="calculator-costs-breakdown__costs">
          {this.props.costs.map(cost => (
            <div className="calculator-costs-breakdown__cost" key={cost.costText}>
              <div className="cost-text">{cost.costText}</div>
              <div className="cost-amount">{cost.costAmount}</div>
            </div>
          ))}
        </div>
        <div className="calculator-costs-breakdown__total">
          <div className="cost-text">{this.props.totalCost.costText}</div>
          <div className="cost-amount">{this.props.totalCost.costAmount}</div>
        </div>
      </div>
    )
  }
}

export default CalculatorCostsBreakdown;
